import useTheme from 'chat-ui/src/hooks/useTheme';
import { Link, useLocation, useParams } from 'react-router-dom';
import Routes from '@/router/routes';
import OrganizationDropDown from './OrganizationDropDown';
import ProjectNavbar from './ProjectNavbar';
import UserIconDropDown from './UserIconDropDown';
import useTranslation from '@/hooks/useTranslation';
import { ECompanyThemeName } from '@/enums';
import useOrganization from '@/hooks/useOrganization';
import { isProjectPage } from '@/utils/isProjectPage';

function Navbar() {
  const location = useLocation();
  const { organization_id: organizationId } = useParams();
  const { currentTheme, themeName } = useTheme();
  const { lang } = useTranslation();

  const { organization } = useOrganization();
  const organizationName = organization?.name;
  const organizationFirstLetter = organization?.name?.[0]?.toUpperCase();
  const isSubscribed = organization?.subscription?.subscribed;

  if (isProjectPage(location.pathname)) {
    return (
      <ProjectNavbar
        isSubscribed={isSubscribed}
        organizationFirstLetter={organizationFirstLetter}
      />
    );
  }

  return (
    <nav
      style={{ backgroundColor: currentTheme?.background }}
      className="fixed left-0 right-0 flex items-center justify-between max-w-full px-[2%] py-2 transition-all ease-in border z-60"
    >
      <OrganizationDropDown
        organizationName={organizationName}
        organizationFirstLetter={organizationFirstLetter}
      />
      <div className="flex items-center gap-4">
        {!isSubscribed && themeName === ECompanyThemeName.DEFAULT && (
          <Link
            className="px-4 py-1.5 text-sm font-semibold text-white rounded-md bg-chat-primary hover:scale-[1.02] transition-all ease-in-out hover:bg-[#ed638a]"
            to={`${Routes.organization.path}/${organizationId}${Routes.choose_your_plan.path}`}
          >
            {lang.get('msg.upgrade')}
          </Link>
        )}
        {/* user profile */}
        <button type="button" aria-label="user profile">
          <UserIconDropDown />
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
